import { siteData } from '@/data/siteData';

export function Contact() {
  return (
    <section id="contact" className="py-20 bg-brand-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-title">Contact Us</h2>
          <p className="section-subtitle">
            Besoek ons kantoore vandag of kontak ons
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Contact Form */}
          <div className="lg:col-span-7 space-y-6">
            <form
              className="space-y-6"
              onSubmit={(e) => {
                e.preventDefault();
                alert('Thank you for your message. We will be in touch shortly.');
              }}
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-brand-navy">
                    Full Name
                  </label>
                  <input
                    type="text"
                    required
                    className="w-full px-4 py-3 rounded-lg border border-brand-navy/20 bg-white focus:outline-none focus:ring-2 focus:ring-brand-gold transition-all"
                  />
                </div>
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-brand-navy">
                    Email Address
                  </label>
                  <input
                    type="email"
                    required
                    className="w-full px-4 py-3 rounded-lg border border-brand-navy/20 bg-white focus:outline-none focus:ring-2 focus:ring-brand-gold transition-all"
                  />
                </div>
              </div>
              <div className="space-y-2">
                <label className="block text-sm font-medium text-brand-navy">
                  Phone Number
                </label>
                <input
                  type="tel"
                  className="w-full px-4 py-3 rounded-lg border border-brand-navy/20 bg-white focus:outline-none focus:ring-2 focus:ring-brand-gold transition-all"
                />
              </div>
              <div className="space-y-2">
                <label className="block text-sm font-medium text-brand-navy">
                  Message
                </label>
                <textarea
                  rows={4}
                  required
                  className="w-full px-4 py-3 rounded-lg border border-brand-navy/20 bg-white focus:outline-none focus:ring-2 focus:ring-brand-gold transition-all"
                />
              </div>
              <button type="submit" className="btn-primary w-full">
                Send Message
              </button>
            </form>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-5 space-y-8">
            {siteData.locations.map((loc) => (
              <div key={loc.name} className="bg-white rounded-xl p-6 border border-brand-navy/10 shadow-sm">
                <h3 className="text-lg font-serif font-bold text-brand-navy mb-1">{loc.name}</h3>
                <p className="text-brand-gold text-sm font-medium mb-4">{loc.address}</p>
                <div className="space-y-3">
                  <div className="flex items-start gap-3">
                    <span className="text-brand-gold mt-0.5">📞</span>
                    <div>
                      <p className="text-sm text-brand-navy/70">Office</p>
                      <p className="text-sm font-medium text-brand-navy">{loc.officePhone}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="text-brand-gold mt-0.5">📱</span>
                    <div>
                      <p className="text-sm text-brand-navy/70">Mobile</p>
                      <p className="text-sm font-medium text-brand-navy">{loc.mobilePhone}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="text-brand-gold mt-0.5">✉</span>
                    <div>
                      <p className="text-sm text-brand-navy/70">Email</p>
                      <p className="text-sm font-medium text-brand-navy">{loc.email}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <div className="bg-white rounded-xl p-6 border border-brand-navy/10 shadow-sm">
              <h3 className="text-lg font-serif font-bold text-brand-navy mb-1">
                Botrivier Agent
              </h3>
              <p className="text-brand-gold text-sm font-medium mb-4">
                {siteData.agent.name}
              </p>
              <div className="space-y-2">
                <div className="flex items-start gap-3">
                  <span className="text-brand-gold mt-0.5">📱</span>
                  <p className="text-sm font-medium text-brand-navy">
                    {siteData.agent.phone} / {siteData.agent.phoneAlt}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 border border-brand-navy/10 shadow-sm">
              <h3 className="text-lg font-serif font-bold text-brand-navy mb-1">
                WhatsApp Chat
              </h3>
              <p className="text-brand-gold text-sm font-medium mb-4">
                Message us directly on WhatsApp
              </p>
              <a
                href={`https://wa.me/${siteData.whatsappPhone.replace('+', '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 w-full btn-primary"
              >
                💬 Chat on WhatsApp
              </a>
            </div>
            <div className="bg-white rounded-xl p-6 border border-brand-navy/10 shadow-sm">
              <h3 className="text-lg font-serif font-bold text-brand-navy mb-1">
                WhatsApp Channel
              </h3>
              <p className="text-brand-gold text-sm font-medium mb-4">
                For updates, information and announcements.
              </p>
              <a
                href={siteData.whatsappChannel}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 w-full btn-outline"
              >
                Follow Channel
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}